import { useLang } from '@/i18n';
import React, { FC } from 'react';
import styles from './index.module.scss';
import { RecommendProductItem } from '../../hooks/types';
import ProductCard from './ProductCard';
import EcoLink from 'eco-design/base/eco-link';
import { useRouter } from 'next/router';

interface RecommendListProps {
    productsDetail: RecommendProductItem[];
}

const RecommendList: FC<RecommendListProps> = ({ productsDetail }) => {
    const { t } = useLang('RecommendList');
    const { locale = 'us' } = useRouter();
    if (productsDetail.length === 0) return null;
    return (
        <div className={styles['recommend-list']}>
            <p className={styles['recommend-list__title']}>{t('title')}</p>
            <section className={styles['recommend-list__products__wrapper']}>
                <div className={styles['recommend-list__products__wrapper-inner']}>
                    {productsDetail.map((product) => (
                        <ProductCard key={product.productId} product={product} />
                    ))}
                </div>
            </section>
            <EcoLink href={`https://${locale}.ecoflow.com/products`} className={styles['recommend-list__shop-all']}>
                {t('shopAll') + ' >>'}
            </EcoLink>
        </div>
    );
};

export default RecommendList;
